<template>
  <div class="floor-warpper">
    <div class="bg-white">
      <div class="flex align-center justify-between margin-bottom-sm">
        <p class="flex align-center">小区名称：
          <el-input :value="communityName" readonly class="flex-sub"></el-input>

          <router-link :to="'/home/floor-management2/' + this.projectId + '/' + this.communityId + '?name='+this.communityName">
            <el-button type="primary">楼栋立体结构</el-button>
          </router-link>


        </p>
        <div class="flex align-center justify-between" style="width: 550px;">
          <el-link :underline="false" target="_blank" href="http://sjfadmin.emof.cn/public/static/roomExcl.xlsx">
            <el-button type="danger">下载楼栋导入模版</el-button>
          </el-link>

          <el-upload
            ref="upload"
            :action="upUrl + '/Index/Importexcel/importRoomList'"
            :limit="1"
            :data="fileData"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :on-success="handleLouSuccess"
          >
            <el-button type="primary">导入楼栋</el-button>
          </el-upload>


          <el-button type="danger" @click="exportRoomList">导出房间信息</el-button>

          <el-upload
            ref="upload2"
            :action="upUrl + '/Index/Importexcel/importRoomListUpdateName'"
            :limit="1"
            :data="fileData"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :on-success="handleRoomSuccess"
          >
            <el-button type="primary">更新房间信息</el-button>
          </el-upload>

        </div>
      </div>

      <div class="flex align-center justify-between">
        <xiaoquLevel @upFive="upFive" :sproject="projectId" :scommunity="communityId" class="basis-lg"/>
        <div class="basis-xsm flex align-center">
          <span>楼门户：</span>
          <el-select v-model="status" placeholder="请选择房间状态" >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <el-button type="primary" @click="hanldSearch">搜索</el-button>
      </div>



      <div class="padding-tb">
        <el-table
          :data="roomList"
          header-row-class-name="table-header"
          row-class-name="table-row"
          alig="center"
          border
          style="width: 100%"
        >
          <el-table-column width="70" type="index" align="center" label="序号">
          </el-table-column>
          <el-table-column label="楼号" prop="building_name"></el-table-column>
          <el-table-column label="单元号" prop="element_name"></el-table-column>
          <el-table-column label="房间号" prop="room_name"></el-table-column>
          <el-table-column label="房间状态" prop="status">
            <template slot-scope="scope">
              {{scope.row.status === 1?'正常':'空置'}}
            </template>
          </el-table-column>
          <el-table-column label="操作" >
            <template slot-scope="scope">
              <div class="table-operate">
                <el-button
                  size="small"
                  type="primary"
                  @click="editItem(scope.row.room_name,scope.row.id,scope.row.status)"
                >编辑房间信息
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="roomList.length > 0"
          class="page-all"
          background
          @current-change="getRoomList"
          :current-page.sync="page"
          :page-size="limit"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <roomDialog
      :roomDialog="roomDialog"
      :editName="editName"
      :editId="editId"
      :editStatus="editStatus"
      @cancelDialog="cancelDialog"
    />
  </div>
</template>

<script>
import {ONLINEHOST, QAHOST} from "@/config";
import {exportRoomListToUpdate, newRoomList} from "@/api/houst";
import roomDialog from "@/views/pages/dialog/roomDialog";
import xiaoquLevel from "@/components/xiaoqu-level";
export default {
  name: "floor-management",
  data() {
    return {
      upUrl: process.env.NODE_ENV === 'production' ? ONLINEHOST : QAHOST,
      projectId: '',
      communityId: '',
      communityName: '',
      building:'',
      unit:'',
      room:'',
      status:'',
      statusList: [
        {value:'',label:'全部'},
        {value:1,label:'正常'},
        {value:2,label:'空置'},
      ],
      roomList:[],
      page: 1,
      limit: 10,
      total: 1,
      noData: false,
      loading:null,
      roomDialog: false,
      editName: '',
      editId: 0,
      editStatus: 1,
    }
  },
  created() {
    this.$emit("setIndex", '/home/community', "系统管理 / 小区管理 / 楼宇管理", true);
    this.projectId = Number(this.$route.params.pid)
    this.communityId = Number(this.$route.params.cid)
    this.communityName = this.$route.query.name
    this.getRoomList()
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    fileData() {
      return {
        token: this.user.token,
        xiangMuId: this.projectId,
        xiaoQuId: this.communityId
      };
    },
  },
  components: {roomDialog,xiaoquLevel},
  methods: {
    hanldSearch(){
      this.page = 1
      this.getRoomList()
    },
    //  楼栋列表
    async getRoomList() {
      let _list = await newRoomList(this.projectId,this.communityId, this.building,this.unit,this.room,'','',this.status,this.page,this.limit)
      if(_list.data.length>0){
        this.roomList = _list.data
        this.total = _list.total_number
      }else{
        this.roomList = []
        this.total = _list.total_number
      }

    },
    beforeAvatarUpload(){
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    //  上传楼栋信息
    handleLouSuccess(res) {
      this.loading.close();
      if (res.status === 200) {
        this.$message.info('请点击导出房间信息，修改房间号并更新')
        this.$refs['upload'].clearFiles()
        this.getRoomList()
      } else {
        this.$message.error(res.info)
        this.$refs['upload'].clearFiles()
      }
    },
    async exportRoomList(){
      let _data = await exportRoomListToUpdate(this.projectId,this.communityId)
      let blob = _data.data
      var downloadElement = document.createElement('a');
      var href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.style.display = 'none';
      downloadElement.href = href;
      downloadElement.setAttribute('download', this.communityName + '房间信息.xls');
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    //  更新房间信息
    handleRoomSuccess(res) {
      this.loading.close();
      if (res.status === 200) {
        this.$message.success('房间信息更新成功')
        this.$refs['upload2'].clearFiles()
        this.getRoomList()
      } else {
        this.$message.error(res.info)
        this.$refs['upload2'].clearFiles()
      }
    },
    //  修改房间信息
    editItem(name, id, status) {
      this.roomDialog = true
      this.editName = name
      this.editId = id
      this.editStatus = status
    },
    //  楼栋设置后回调
    cancelDialog() {
      this.roomDialog = false
      this.editName = ''
      this.editId = 0
      this.editStatus = 1
      this.getRoomList()
    },
    //  同步更新五级联动
    upFive(val) {
      this.building = val.building
      this.unit = val.unit
      this.room = val.room
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.floor-warpper {
  .floor-list {
    .floor-item {
      width: 150px;
      min-height: 80px;
      padding: 20px;
      margin: 0 30px 30px 0;
      border: 1px solid #d00000;

      p {
        font-size: 16px;
        text-align: center;
        margin-bottom: 10px;
      }

      .el-button {
        padding: 0;
      }
    }
  }

  .no-data {
    img {
      display: block;
      margin: 30px auto;
    }

    p {
      text-align: center;
    }
  }
}

</style>
